import { CompanyColumnKey } from './types';

export const columnKeys: CompanyColumnKey[] = [
    'LogoType',
    'Name',
    'SuperAdminSettings.DemoMeeting',
    'SuperAdminSettings.StartupMeeting',
    'OrganisationNumber',
    'StatusId',
    'Phone',
    'Email',
    'Active',
    'Id',
];
